import serviceSlider from '../components/serviceSlider.svelte'
import showroom from '../components/showroom.svelte'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

let tl = gsap.timeline({})

const { $, boostServiceSlider, boostShowroom } = window

export default {
	init() {
		let serviceSliderContainer = document.getElementById('serviceSlider')
		serviceSliderContainer &&
			new serviceSlider({
				target: serviceSliderContainer,
				props: {
					services: boostServiceSlider,
				},
			})

		let showroomContainer = document.getElementById('showroom')
		showroomContainer &&
			new showroom({
				target: showroomContainer,
				props: {
					showrooms: boostShowroom,
				},
			})
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
		let $wrapperElem = $('.wpb_wrapper')
		if ($wrapperElem.length) {
			document
				.querySelectorAll(
					'.wpb_wrapper:not(.home-slider .wpb_wrapper, .granite-element > .wpb_wrapper)'
				)
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ x: -50, opacity: 0 },
						{
							scrollTrigger: item,
							delay: 0.5,
							duration: 0.5,
							x: 0,
							opacity: 1,
						}
					)
				})
		}

		let $videoContainer = $('#videoContainer')
		if ($videoContainer.length) {
			gsap.fromTo(
				'#videoContainer',
				{ translateX: 50, opacity: 0 },
				{
					scrollTrigger: '#videoContainer',
					delay: 1,
					duration: 1,
					translateX: 0,
					opacity: 1,
				}
			)
			gsap.fromTo(
				'#introElement',
				{ width: 0, opacity: 0 },
				{
					scrollTrigger: '#videoContainer',
					delay: 1,
					duration: 1,
					width: 500,
					opacity: 1,
				}
			)
			gsap.fromTo(
				'#introElement2',
				{ width: 0, opacity: 0 },
				{
					scrollTrigger: '#videoContainer',
					delay: 1,
					duration: 1,
					width: 500,
					opacity: 1,
				}
			)
		}

		let $serviceSliderSection = $('#serviceSliderSection')
		if ($serviceSliderSection.length) {
			gsap.fromTo(
				'#serviceSliderSection',
				{ x: -50, opacity: 0 },
				{
					scrollTrigger: '#serviceSliderSection',
					delay: 1,
					duration: 1,
					x: 0,
					opacity: 1,
				}
			)
			gsap.fromTo(
				'#lineElement',
				{ width: 0, opacity: 0 },
				{
					scrollTrigger: '#serviceSliderSection',
					delay: 1,
					duration: 1,
					width: 409,
					opacity: 1,
				}
			)
			// document.querySelectorAll('.service-item').forEach((item, i) => {
			// 	gsap.fromTo(
			// 		'.service-item',
			// 		{ y: -50, opacity: 0 },
			// 		{
			// 			scrollTrigger: '#serviceSliderSection',
			// 			delay: i * 0.75,
			// 			duration: 1,
			// 			y: 0,
			// 			opacity: 1,
			// 		}
			// 	)
			// })
		}

		let $craftsmenSection = $('#craftsmenSection')
		if ($craftsmenSection.length) {
			gsap.fromTo(
				'#craftsmenElemTop',
				{ width: 0, opacity: 0 },
				{
					scrollTrigger: '#craftsmenSection',
					delay: 1,
					duration: 1,
					width: 500,
					opacity: 1,
				}
			)
			gsap.fromTo(
				'#craftsmenElemBottom',
				{ width: 0, opacity: 0 },
				{
					scrollTrigger: '#craftsmenSection',
					delay: 1,
					duration: 1,
					width: 500,
					opacity: 1,
				}
			)
		}

		// let $threeBuckets = $('#threeBuckets')
		// if ($threeBuckets.length) {
		// 	document.querySelectorAll('#threeBuckets > .bucket').forEach((item) => {
		// 		gsap.fromTo(
		// 			item,
		// 			{ y: -50, opacity: 0 },
		// 			{
		// 				scrollTrigger: item,
		// 				delay: item * 0.5,
		// 				duration: 0.5,
		// 				y: 0,
		// 				opacity: 1,
		// 			}
		// 		)
		// 	})
		// }
	},
}
